import { render, staticRenderFns } from "./PaginationWithPerPage.vue?vue&type=template&id=75ed1b60&scoped=true"
import script from "./PaginationWithPerPage.vue?vue&type=script&lang=js"
export * from "./PaginationWithPerPage.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "75ed1b60",
  null
  ,true
)

export default component.exports